<template>
  <div
    class="banner"
    :class="{
      'standard-banner': type === 'standard',
      'accent-banner': type === 'accent',
      'information-banner': type === 'information',
      'success-banner': type === 'success',
      'warning-banner': type === 'warning',
      'error-banner': type === 'error',
    }"
  >
    <div class="container mx-width"><slot></slot></div>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: 'standard',
      validator: (value) => {
        return ['standard', 'accent', 'information', 'success', 'warning', 'error'].indexOf(value) !== -1;
      },
    },
  },
};
</script>
<style lang="postcss">
@import '@/pixel/style/variables';

.banner {
  width: 100%;
  padding-top: 6px;
  padding-bottom: 6px;
  text-align: center;
  background-color: var(--background-color);

  &.standard-banner,
  &.standard-banner a {
    background-color: var(--background-color);
  }

  &.accent-banner {
    padding-top: 12px;
    padding-bottom: 12px;
  }

  &.accent-banner,
  &.accent-banner a {
    background-color: var(--coral-light);
    color: var(--accent-color);
  }

  &.information-banner {
    background-color: var(--information-color);
    color: white;
  }

  &.success-banner {
    background-color: var(--success-color);
    color: white;
  }

  &.warning-banner {
    background-color: var(--warning-color);
    color: white;
  }

  &.error-banner {
    background-color: var(--error-color);
    color: white;
  }
}
</style>
